<template>
  <div
    class="dashboard-metric-chip group relative inline-flex flex-col gap-1 rounded-2xl border border-primary-200 bg-primary-100 bg-opacity-70 px-3 py-2"
    tabindex="0"
    @mouseenter="repositionTooltip"
    @focus="repositionTooltip"
  >
    <span v-if="label" class="text-sm text-black font-semibold uppercase tracking-widest leading-none">{{ label }}</span>
    <slot name="value">
      <span class="flex items-center gap-1 text-sm font-semibold text-primary-600">
        <slot name="value-text">{{ value }}</slot>
      </span>
    </slot>
    <span
      v-if="tooltip"
      :id="computedTooltipId"
      ref="tooltipRef"
      role="tooltip"
      class="pointer-events-none absolute left-1/2 top-[110%] z-20 -translate-x-1/2 rounded-md bg-gray-900 px-3 py-2 text-[0.7rem] sm:text-xs font-medium text-white opacity-0 shadow-lg ring-1 ring-black/40 transition-opacity duration-150 group-hover:opacity-100 group-focus:opacity-100 whitespace-normal max-w-[85vw]"
    >{{ tooltip }}</span>
  </div>
</template>

<script>
let uid = 0

export default {
  name: 'DashboardMetricChip',
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    },
    tooltipId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      uidSuffix: ++uid
    }
  },
  computed: {
    computedTooltipId () {
      if (!this.tooltip) {
        return null
      }
      return this.tooltipId || `dashboard-metric-chip-${this.uidSuffix}`
    }
  },
  methods: {
    repositionTooltip () {
      if (!this.tooltip) {
        return
      }
      this.$nextTick(() => {
        const tooltip = this.$refs.tooltipRef
        if (!tooltip) {
          return
        }
        tooltip.style.position = 'fixed'
        tooltip.style.left = '0px'
        tooltip.style.top = '0px'
        tooltip.style.transform = 'none'
        tooltip.style.visibility = 'hidden'
        tooltip.style.opacity = '1'

        const chipRect = this.$el.getBoundingClientRect()
        const tipRect = tooltip.getBoundingClientRect()
        const viewportWidth = window.innerWidth
        const padding = 8

        let left = chipRect.left + (chipRect.width / 2) - (tipRect.width / 2)
        left = Math.max(padding, Math.min(left, viewportWidth - tipRect.width - padding))
        const top = chipRect.bottom + 8

        tooltip.style.left = `${left}px`
        tooltip.style.top = `${top}px`
        tooltip.style.transform = 'none'
        tooltip.style.visibility = ''
        tooltip.style.opacity = ''
      })
    }
  }
}
</script>
